// extracted by mini-css-extract-plugin
export default {"card":"LiveCard_card__XhAx7","date":"LiveCard_date__qGJAh","location":"LiveCard_location__165LS","heading":"LiveCard_heading__JvK0B"};